/* KAAFEY v5 — schuif tussen gemalen koffie en capsule: tikken, het knopje slepen of de kaart swipen. */
(function () {
  function init(root) {
    var track = root.querySelector('[data-choice-track]');
    var tabs = [].slice.call(root.querySelectorAll('[data-choice-tab]'));
    var sw = root.querySelector('.choice-switch');
    var thumb = root.querySelector('.choice-thumb');
    if (!track || tabs.length < 2) return;
    var reduce = matchMedia('(prefers-reduced-motion: reduce)').matches;
    var current = 0;
    function track_(n) { try { (window.kaafeyTrack || function () {})('coffee_choice_view', { choice: n ? 'capsule' : 'ground' }, false); } catch (e) {} }
    function mark(n) {
      if (n === current) return;
      current = n;
      tabs.forEach(function (t, i) { t.setAttribute('aria-selected', i === n ? 'true' : 'false'); t.tabIndex = i === n ? 0 : -1; });
      track_(n);
    }
    function go(n) {
      track.scrollTo({ left: track.clientWidth * n, behavior: reduce ? 'auto' : 'smooth' });
      root.style.setProperty('--p', n);
      mark(n);
    }
    tabs.forEach(function (t, i) {
      t.addEventListener('click', function () { go(i); });
      t.addEventListener('keydown', function (e) {
        if (e.key === 'ArrowRight' || e.key === 'ArrowLeft') { var n = e.key === 'ArrowRight' ? 1 : 0; go(n); tabs[n].focus(); e.preventDefault(); }
      });
    });
    // swipe op de kaart: knopje loopt live mee
    var raf = 0;
    track.addEventListener('scroll', function () {
      if (raf) return;
      raf = requestAnimationFrame(function () {
        raf = 0;
        var p = Math.max(0, Math.min(1, track.scrollLeft / Math.max(1, track.scrollWidth - track.clientWidth)));
        if (!root.classList.contains('is-dragging')) root.style.setProperty('--p', p.toFixed(3));
        mark(p > .5 ? 1 : 0);
      });
    }, { passive: true });
    // knopje slepen (pas als er echt bewogen wordt, zodat tikken op een tab gewoon werkt)
    var pressed = false, dragging = false, startX = 0, startP = 0, pid = null;
    sw.addEventListener('pointerdown', function (e) {
      if (e.button !== undefined && e.button !== 0) return;
      pressed = true; dragging = false; startX = e.clientX; startP = current; pid = e.pointerId;
    });
    sw.addEventListener('pointermove', function (e) {
      if (!pressed) return;
      var dx = e.clientX - startX;
      if (!dragging) {
        if (Math.abs(dx) < 8) return;
        dragging = true; root.classList.add('is-dragging');
        try { sw.setPointerCapture(pid); } catch (err) {}
      }
      var p = Math.max(0, Math.min(1, startP + dx / (sw.clientWidth / 2)));
      root.style.setProperty('--p', p.toFixed(3));
      track.scrollLeft = p * (track.scrollWidth - track.clientWidth);
    });
    function up() {
      if (!pressed) return;
      pressed = false;
      if (!dragging) return;
      dragging = false; root.classList.remove('is-dragging');
      var p = parseFloat(root.style.getPropertyValue('--p')) || 0;
      go(p > .5 ? 1 : 0);
      var stop = function (ev) { ev.stopPropagation(); ev.preventDefault(); };
      sw.addEventListener('click', stop, true);
      setTimeout(function () { sw.removeEventListener('click', stop, true); }, 350);
    }
    sw.addEventListener('pointerup', up);
    sw.addEventListener('pointercancel', up);
  }
  function boot() { document.querySelectorAll('[data-choice]').forEach(init); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
})();
